<script lang="ts">
  /* eslint-disable @typescript-eslint/no-unused-vars */
  import { page } from '$app/stores';
  import { goto } from '$app/navigation';
  import { isDev } from '$lib/config';
  import { Switch, Case } from '$components/Switch';
</script>

<template lang="pug" src="./error.pug">
</template>

<svelte:head>
  <style lang="scss" src="./error.scss"></style>
</svelte:head>
